export const ADDPPermissions = {
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
    NONE: 'NONE',
    READ_ONLY: 'READ_ONLY',
    PARTIAL: 'PARTIAL',
    FULL: 'FULL'
};

export const ADDPPermissionMessages = {
    NotEligible: 'Sorry, Co. is not eligible. Contact your Sales Rep',
    NoPermission: 'Company is eligible, you lack permssions = can learn only',
    ReadOnlyPermission: 'Company is eligible, you have Read Only permssions = use hamburger menu to navigate',
    PartialUpdatePermission: 'Company is eligible, has partial permissions, contact your lead TCM for Sign-Up'
};
